<template>
	<div class="dashboard">
		<!-- necessary div. dot not remove -->
		<div class="">
			<BHeader
				backgroundMobile="dashboard-splash.png"
				backgroundDesktop="transparent"
				:increasedHeightMobile="true"
			/>
		</div>

		<div class="body | container">
			<div class="splashImg"></div>

			<div class="content">
				<div class="intro">
					<div class="title">
						<p class="title__line1">
							{{
								$t("dashboardTitleLine1", {
									name: `${user.firstName} ${user.lastName}`,
								})
							}}
						</p>
						<p class="title__line2">
							{{ $t("dashboardTitleLine2") }}
						</p>
					</div>
				</div>

				<div class="simCards" v-if="!isLoading">
					<div class="simCards__highlighted">
						<BSimCard
							v-if="lastSimHistoryItem"
							class="simCards__highlightedSimCard"
							:icon="
								lastSimHistoryItem.status === 'PENDING' ? 'ITime' : 'IDocument'
							"
							variant="secondary"
							:description="
								lastSimHistoryItem.status === 'PENDING'
									? $t('Simulação Pausada')
									: $t('Última Simulação')
							"
							:title="lastSimHistoryItem.title"
							:date="lastSimHistoryItem.date"
							@click="handleSimCardClick(lastSimHistoryItem)"
						/>

						<BSimCard
							class="simCards__highlightedSimCard"
							:description="$t('Nova Simulação')"
							:title="$t('Começar nova simulação')"
							icon="ArrowDown"
							@click="handleNewSimCardClick"
						/>
					</div>

					<BSimHistoryCard
						class="simCards__historyCard"
						v-if="simHistoryItems && simHistoryItems.length"
						:items="simHistoryItems"
					/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapActions, mapState } from "vuex";

import { BDropdown, BDropdownItem } from "@/components/base/BDropdown/index.js";
import BLangSelector from "@/components/base/BLangSelector";
import BSimCard from "@/components/base/BSimCard";
import BSimHistoryCard from "@/components/base/BSimHistoryCard.vue";
import BHeader from "../../components/base/BHeader.vue";

export default {
	components: {
		BDropdown,
		BDropdownItem,
		BLangSelector,
		BSimCard,
		BSimHistoryCard,
		BHeader,
	},
	data() {
		return {
			isLoading: false,
		};
	},
	computed: {
		...mapState("user", ["user"]),
		...mapState("simulations", ["simulationSummaries"]),

		simHistoryItems() {
			return (
				this.simulationSummaries?.map((summary) => {
					return {
						id: summary.id,
						title: summary.name,
						date: summary.lastUpdateDate,
						description: summary.simulationType,
						status: summary.calculationStatus,
					};
				}) ?? []
			);
		},

		lastSimHistoryItem() {
			return this.simHistoryItems[0];
		},
	},
	methods: {
		...mapActions("simulations", ["fetchSimulationSummaries"]),

		handleSimCardClick(simHistoryItem) {
			this.$router.push({
				name: "Simulator",
				params: {
					simulation: simHistoryItem.id,
				},
			});
		},

		handleNewSimCardClick() {
			this.$router.push({
				name: "SimulatorNew",
			});
		},
	},
	created() {
		this.isLoading = true;
		this.fetchSimulationSummaries().finally(() => {
			this.isLoading = false;
			this.$emit("loaded");
		});
	},
};
</script>

<style lang="scss" scoped>
.dashboard {
	display: flex;
	gap: 20px;
	flex-direction: column;
	min-height: 100vh;
	background: var(--color-neutral-50);
	padding-bottom: 40px;
}

.splashImg {
	background-image: url("../../assets/img/dashboard-splash.png");
	background-size: cover;
	background-position: top center;
	border-radius: 16px;
}

.body {
	display: grid;
	flex: 1;
	grid-template-columns: 1fr 1fr;
	gap: 20px;
}

.content {
	display: grid;
	grid-template-rows: 1fr 1fr;
}

.intro {
	flex-grow: 1;
	display: flex;
	flex-direction: column;
	justify-content: center;
	padding: 0 20px;
}

.title {
	font-size: var(--font-size-xl);
	line-height: 1.11;
	text-wrap: balance;
}

.title__line1 {
	font-weight: var(--font-weight-bold);
	color: var(--color-primary-800);
}

.title__line2 {
	font-weight: var(--font-weight-light);
	color: var(--color-primary-600);
}

.simCards {
	&:where(:has(.simCards__historyCard)) {
		display: grid;
		grid-template-columns: 1fr 1fr;
		gap: 20px;
	}
}

.simCards__highlighted {
	height: 100%;
	display: grid;
	grid-template-columns: 1fr;
	gap: 20px;
}

.simCards__highlightedSimCard {
	height: 100%;
}

@media (max-width: 768px) {
	.dashboard {
		min-height: auto;
		padding-bottom: 20px;
	}

	.body,
	.content {
		display: block;
	}

	.splashImg {
		display: none;
	}

	.intro {
		margin-bottom: 30px;
	}

	.simCards {
		&:has(.simCards__historyCard) {
			display: block;
		}
	}

	.simCards__highlighted {
		grid-template-columns: 1fr 1fr;
		gap: 10px;
		margin-bottom: 10px;
	}
}
</style>
